import { axiosInstance } from '@/lib/axios'
import { AmountsPreviewQuery, AmountsPreviewOutput } from './types'
import { formatDate } from '@/modules/shared/utils/date'

const prepareDate = (date: AmountsPreviewQuery['yearMonth']): string => {
  const _date =
    typeof date === 'number' || typeof date === 'string' ? new Date(date) : date
  return formatDate(_date, 'YYYY-MM-DD')
}

export function getAmountsPreview({
  companyId,
  driverId,
  yearMonth,
}: AmountsPreviewQuery) {
  return axiosInstance.get<AmountsPreviewOutput>(
    `/api/${companyId}/timesheet/amountsPreview`,
    {
      params: {
        driverId,
        date: prepareDate(yearMonth),
      },
    },
  )
}
